import NewsTipFilter from './NewsTipFilter'

export default NewsTipFilter
